// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getKeysRecurse = (obj: Record<string, any>): string[] => {
  let result: string[] = [];
  Object.entries(obj).forEach(([key, value]) => {
    let keys: string[] = [];
    if (Array.isArray(value)) {
      keys = [];
      value.forEach((element) => {
        if (typeof element === 'object') {
          keys.push(...getKeysRecurse(element));
        }
      });
    } else if (typeof value === 'object') {
      keys = [...getKeysRecurse(value)];
    } else {
      keys = [key];
    }
    result = [...result, ...keys];
  });
  return result;
};
